export enum BoardType {
  BountyBoard = 'BountyBoard',
  BountyLeague = 'BountyLeague',
}

export enum BoardMainComponent {
  BountyBoard = 'BountyBoardMain',
  BountyLeague = 'BountyLeagueMain',
}
